import createActions from 'utils/redux/createActions'

export default createActions([
	'AGENTS_FILTER_UPDATED'
  , 'CLEAR_AGENTS_FILTERS'
])



// WEBPACK FOOTER //
// ./src/actions/agents.js